// Rules for the customer data (#11), shared by worker and frontend. No imports: the frontend loads this file in the browser.

/**
 * File types Claude can read. Old binary Office formats (.xls, .doc, .ppt) are left out because the worker has no
 * converter (#16). Extending the list needs no ADR.
 */
export const CUSTOMER_DATA_TYPES: Readonly<Record<string, string>> = {
  '.xlsx': 'Excel',
  '.csv': 'CSV',
  '.docx': 'Word',
  '.pptx': 'PowerPoint',
  '.pdf': 'PDF',
  '.txt': 'Text',
  '.md': 'Markdown',
  '.json': 'JSON',
  '.xml': 'XML',
  '.png': 'Image',
  '.jpg': 'Image',
  '.jpeg': 'Image',
};

/** Upper bound for a single file; the quota per customer comes from customers.yaml. */
export const CUSTOMER_DATA_MAX_FILE_BYTES = 500 * 1024 * 1024;

/** Lower-case extension including the dot, or '' if the name has none. */
export function extensionOf(name: string): string {
  const dot = name.lastIndexOf('.');
  return dot <= 0 ? '' : name.slice(dot).toLowerCase();
}

export function isAllowedDataFile(name: string): boolean {
  return Object.hasOwn(CUSTOMER_DATA_TYPES, extensionOf(name));
}

